import { render } from "./SelectedHospital.vue?vue&type=template&id=1e8cdad6&ts=true"
import script from "./SelectedHospital.vue?vue&type=script&lang=ts"
export * from "./SelectedHospital.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__